import { render, staticRenderFns } from "./Whitelist.vue?vue&type=template&id=c20f3fc0"
import script from "./Whitelist.vue?vue&type=script&lang=js"
export * from "./Whitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports